// Bengali translations (বাংলা)
export const bn = {
  // Common
  common: {
    home: 'হোম',
    settings: 'সেটিংস',
    language: 'ভাষা',
    loading: 'লোড হচ্ছে...',
    save: 'সংরক্ষণ',
    cancel: 'বাতিল',
    confirm: 'নিশ্চিত করুন',
    close: 'বন্ধ করুন',
    back: 'Back',
    continue: 'Continue',
    accept: 'Accept',
    decline: 'Decline',
    contactEmail: 'contact@zodiac-chess.com',
    companyName: 'Animal Chess Limited',
    companyCountry: 'New Zealand',
  },

  // Settings Menu
  settings: {
    header: 'সেটিংস',
    home: 'হোম',
    howToPlay: 'কিভাবে খেলবেন',
    pieceRules: 'গুটির নিয়ম',
    language: 'ভাষা',
    manageSubscription: 'সাবস্ক্রিপশন পরিচালনা',
    gameHistory: 'খেলার ইতিহাস',
    analytics: 'বিশ্লেষণ',
    premiumAccount: 'প্রিমিয়াম অ্যাকাউন্ট',
    chatEnabled: 'চ্যাট: চালু',
    chatDisabled: 'চ্যাট: বন্ধ',
  },

  // Piece Rules
  pieceRules: {
    title: 'গুটির নিয়ম',
    description: 'গুটির চাল শিখুন',
    selectPiece: 'গুটি নির্বাচন করুন',
    selectedLabel: 'নির্বাচিত:',
    statusLabel: 'অবস্থা:',
    statusReady: 'প্রস্তুত',
    statusViewing: 'দেখা হচ্ছে',
    movement: 'চলাচল',
    regularMovement: 'সাধারণ চলাচল',
    ability: 'ক্ষমতা',
      backToSelection: 'Back to selection',
    backToHome: 'Back to home',
  },

  // Move/Ability Names
  moves: {
    movement: 'চলাচল',
    savage: 'বন্য',
    birdtype: 'পাখির ধরন',
    birdType: 'পাখির ধরন',
    wallBlock: 'দেয়াল বাধা',
    moveblocks: 'চলার বাধা',
    wallclimb: 'দেয়াল বেয়ে ওঠা',
    lilypad: 'পদ্মপাতা',
    poisonous: 'বিষাক্ত',
    meadow: 'তৃণভূমি',
    parasiticfungi: 'পরজীবী ছত্রাক',
    zombification: 'জম্বিফিকেশন',
    fungi: 'ছত্রাক',
    traverse: 'অতিক্রম',
    capture: 'ধরা',
    faint: 'অজ্ঞান',
    leap: 'লাফ',
    swing: 'দোল',
    consume: 'খাওয়া',
    gamble: 'জুয়া',
    entangle: 'জড়ানো',
    ink: 'কালি',
    rotate: 'ঘোরানো',
    backstep: 'পিছনে যাওয়া',
    trample: 'পদদলিত',
    charge: 'আক্রমণ',
    lane: 'লেন',
    snakestrike: 'সাপের আঘাত',
    shedskin: 'খোলস ফেলা',
    house: 'ঘর',
    plant: 'উদ্ভিদের ধরন',
    planttype: 'উদ্ভিদের ধরন',
    capturehost: 'হোস্ট ধরা',
    contagion: 'সংক্রমণ',
    lonewolf: 'একাকী নেকড়ে',
    hop: 'লাফানো',
    decay: 'ক্ষয়',
    slide: 'স্লাইড',
    block: 'বাধা',
    poison: 'বিষ',
    infection: 'সংক্রমণ',
    howl: 'চিৎকার',
  },

  // Animation Scenario Descriptions
  scenarios: {
    // Bear
    bearMovement: 'ভালুক দাবার রাজার মতো যেকোনো দিকে একটি ঘর সরতে পারে',
    bearMovementPost: 'এটি শুধুমাত্র বন্ধু গুটি দ্বারা বাধাপ্রাপ্ত হয় (গাছ ছাড়া, ভালুক গাছে উঠতে পারে!)',
    bearSavage: 'একটি ভালুক গন্ডারের বাধার মতো প্রতিরক্ষামূলক ক্ষমতা অতিক্রম করতে পারে',
    bearSavagePost: 'বন্য ব্যবহার করে ভালুক যেকোনো দিক থেকে যেকোনো গুটি ধরতে পারে, প্রাণঘাতীতা যোগ করে',

    // Crane
    craneMovement: 'সারস যেকোনো সরল রেখায় ১ বা ২ ঘর সরতে পারে',
    craneMovementPost: 'সারস এমনকি অন্যান্য গুটির উপর দিয়ে উড়তে পারে!',
    craneBirdType: 'পাখির ধরনের গুটি বড় বা শিকারী গুটি ধরতে পারে না',
    craneBirdTypePost: 'এর মধ্যে রয়েছে গাছ, গন্ডার, ভালুক এবং নেকড়ে',

    // Frog
    frogMovement: 'ব্যাঙ কর্ণাকর্ণিভাবে ২ ঘর লাফ দেয়',
    frogMovementPost: 'এটি শুধুমাত্র একটি লাফ দিতে পারে না',
    frogWallBlock: 'যদি ব্যাঙের নিয়মিত ২ ঘর পথ একটি দেয়াল বা অন্য গুটি দ্বারা বাধাপ্রাপ্ত হয় তবে এটি ধরতে পারে না',
    frogWallBlockPost: 'এর নিয়মিত চলাচল কর্ণাকর্ণিভাবে ১ ঘরে সংক্ষিপ্ত হয়',
    frogWallClimb: 'যখন ব্যাঙ বোর্ডের দেয়ালে (কলাম A বা E) থাকে তখন এটি উপরে বা নিচে এক সরতে পারে',
    frogWallClimbPost: 'যদি না বন্ধু গুটি বা ব্যাঙের সামনে গন্ডার দ্বারা বাধাপ্রাপ্ত হয়',
    frogLilypad: 'যদি ব্যাঙ এখনও খেলায় সরে না থাকে, তবে এটি প্রথম ৩টি র‍্যাঙ্কের যেকোনো একটিতে একটি শক্তিশালী প্রতিরক্ষামূলক ক্ষমতা হিসাবে সরতে পারে',
    frogLilypadPost: 'এটি পদ্মপাতা লাফ ব্যবহার করে যেকোনো নিয়মিত গুটি ধরতে পারে, শুধুমাত্র নিজের চেয়ে উচ্চতর র‍্যাঙ্কে থাকা গন্ডার ছাড়া',
    frogPoisonous: 'যখন কোনো প্রাণী একটি ব্যাঙ গুটি ধরে, আপনি বিষাক্ত হয়ে যান!',
    frogPoisonousPost: 'একটি বিষাক্ত গুটি পুনরুদ্ধারের আগে তার পরবর্তী উপলব্ধ পালা এড়িয়ে যায়',

    // Fungi
    fungiMovement: 'ছত্রাক যেকোনো দিকে একটি ঘর সরতে পারে',
    fungiMovementPost: 'এটি শুধুমাত্র মিত্র গুটি দ্বারা বাধাপ্রাপ্ত হয়',
    fungiMeadow: 'ছত্রাক শত্রু গাছ গুটির চলাচল ক্ষমতা হ্রাস করে',
    fungiMeadowPost: 'শত্রু গাছ গুটি ছত্রাক গুটির ১ ঘরের মধ্যে সরতে পারে না',
    fungiParasitic: 'ছত্রাক শত্রু গাছ গুটিকে স্থির করতে পারে',
    fungiParasiticPost: 'যদি ছত্রাক শত্রু গাছের ১ ঘরের মধ্যে থাকে তবে ছত্রাক সরে না যাওয়া বা ধরা না হওয়া পর্যন্ত এটি সরতে পারে না',
    fungiZombification: 'ছত্রাক যেকোনো শত্রু প্রাণী গুটিকে জম্বিফাই করতে পারে যা এটি ধরে, এক পালার জন্য শত্রু প্রাণীর উপর নিয়ন্ত্রণ অনুমতি দেয়',
    fungiZombificationPost: 'জম্বিফাইড গুটিকেও সেই পালার জন্য ছত্রাক গুটি হিসাবে বিবেচনা করা হয়, এমনকি যদি ছত্রাক আপনার রাজা ছিল তবে সেই পালার পরে খেলা শেষ হয় না',
    fungiFungi: 'ছত্রাক',
    fungiFungiPost: 'যেমন বিষ, জড়ানো এবং ভাইরাস সংক্রমণ, কিন্তু জম্বিফিকেশন নয় কারণ এটি অন্যদের জম্বিফাই করতে পারে!',

    // Goat
    goatMovement: 'ছাগল যেকোনো দিকে একটি ঘর সরতে পারে',
    goatMovementPost: 'ছাগল ধীরে সরে কিন্তু শক্তিশালী ক্ষমতা আছে',
    goatTraverse: 'ছাগল বিশাল চলাচল সম্ভাবনা তৈরি করতে যেকোনো অন্য সংযুক্ত গুটির মধ্য দিয়ে যেতে পারে',
    goatTraversePost: 'ছাগল অজ্ঞান ছাগল বা ভাইরাসের মতো ক্ষুদ্র গুটির উপর দিয়ে যেতে পারে না',
    goatCapture: 'ছাগল কোনো শিকারী ধরতে পারে না',
    goatCapturePost: 'যেমন ভালুক বা নেকড়ে',
    goatFaint: 'ছাগল গাছ এবং গন্ডারের মতো বড় গুটি ছাড়া ধরা এড়াতে অজ্ঞান হতে পারে',
    goatFaintPost: 'অজ্ঞান থাকাকালীন, প্রতিপক্ষরা অজ্ঞান ছাগলের উপর "দাঁড়িয়ে" এর চলাচল বন্ধ করতে পারে',

    // Monkey
    monkeyMovement: 'বানর যেকোনো দিকে একটি ঘর সরতে পারে',
    monkeyMovementPost: 'ব্যবহার করার জন্য অন্যান্য গুটি ছাড়া বানরের সীমিত চলাচল আছে',
    monkeyLeap: 'বানর, ড্রাফ্ট খেলার মতো, বিশাল চলাচল সম্ভাবনার জন্য সরল রেখায় অন্যান্য গুটির উপর দিয়ে লাফ দিতে পারে',
    monkeyLeapPost: 'কিন্তু যদি শত্রু গুটির উপর দিয়ে লাফ দেয়, তবে বানরকে লাফ থেকে বাঁচতে একটি ডাইস রোল করতে হবে, প্রতিটি শত্রু লাফানোর জন্য ১/৬ ধরার সম্ভাবনা!',
    monkeySwing: 'যদি একটি বানর একটি গাছের উপর দিয়ে লাফ ব্যবহার করে, তবে বানর একটি বোনাস পালা পায়',
    monkeySwingPost: 'গাছের দোল ব্যবহার করে বানর এবং গাছ গুটির মধ্যে একটি শক্তিশালী সিনার্জিস্টিক কম্বো তৈরি করে',
    monkeyConsume: 'বানর একটি বোনাস পালার জন্য একটি ছত্রাক গুটি খেতে পারে',
    monkeyConsumePost: 'অন্যান্য বোনাস পালার সাথে মিলিত হলে ধ্বংসাত্মক সংমিশ্রণের দিকে পরিচালিত করে',
    monkeyGamble: 'শত্রুদের উপর দিয়ে লাফানোর জন্য ডাইস রোল করা ছাড়াও, বানরকে ভালুক ধরতে জুয়া খেলতে হবে',
    monkeyGamblePost: 'বানরকে ভালুক ধরতে ৬ পার্শ্বযুক্ত ডাইসে ৫ বা ৬ রোল করতে হবে নইলে এটি নিজেই ধরা পড়বে',

    // Octopus
    octopusMovement: 'অক্টোপাস যেকোনো দিকে একটি ঘর সরে',
    octopusCapture: 'অক্টোপাস শুধুমাত্র অর্থোগোনালভাবে ধরতে পারে',
    octopusCapturePost: 'অক্টোপাস জটিল উপায়ে গুটি ধরতে বা জড়াতে পারে তাই সর্বদা লাল ধরা এবং বেগুনি জড়ানোর জন্য পরীক্ষা করুন!',
    octopusEntangle: 'অক্টোপাস সংলগ্ন শত্রু গুটি জড়াতে পারে, তাদের স্থির করে, এটি এমনকি একটি ঘর সরতে এবং শত্রুদের জড়াতে পারে!',
    octopusEntanglePost: 'জড়ানো গুটি সরতে পারে না যতক্ষণ না অক্টোপাস সরে যায় বা ধরা পড়ে',
    octopusInk: 'অক্টোপাস বিপজ্জনক পরিস্থিতি থেকে পালাতে কালি ব্যবহার করতে পারে, ৩টি পর্যন্ত ছায়া তৈরি করে',
    octopusInkPost: 'শত্রুকে বিভ্রান্ত করে এবং আকর্ষণীয় টোপ এবং এড়ানোর খেলার অনুমতি দেয়',

    // Penguin
    penguinMovement: 'পেঙ্গুইন তার সেট দিকে সরল রেখায় স্লাইড করে যতক্ষণ না একটি দেয়াল বা গুটি তার চলাচল বাধা দেয়',
    penguinMovementPost: 'সরানোর পরে, পেঙ্গুইন একই পালার মধ্যে তার চূড়ান্ত দিক সেট করতে পারে',
    penguinRotate: 'ম্যাচের শুরুতে একটি পেঙ্গুইন নিচের দিকে মুখ করে থাকে এবং স্লাইড করতে সক্ষম হওয়ার আগে ঘোরাতে হবে, যা ঘুমানো হিসাবেও পরিচিত',
    penguinRotatePost: 'যেকোনো অবস্থানে পেঙ্গুইন সরানোর পরিবর্তে ঘোরাতে বেছে নিতে পারে',
    penguinBirdType: 'পেঙ্গুইনের সীমিত ধরার ক্ষমতা আছে, সারসের মতো, এটি গাছ, গন্ডার, ভালুক বা নেকড়ের মতো বড় বা শিকারী গুটি ধরতে পারে না',
    penguinBirdTypePost: 'ধরার পরে, পেঙ্গুইন কৌশলগত অবস্থানের জন্য যেকোনো দিকে মুখ করতে ঘোরাতে পারে',

    // Rhino
    rhinoMovement: 'গন্ডার শুধুমাত্র সামনের দিকে দুটি ঘর সরে',
    rhinoMovementPost: 'এটি শুধুমাত্র ১ ঘর সরতে পারে না',
    rhinoBackStep: 'গন্ডার পিছনে-বাম বা পিছনে-ডানে সরতে পারে',
    rhinoCharge: 'গন্ডার প্রতি খেলায় একবার তার চার্জ ক্ষমতা ব্যবহার করে সামনের দিকে একটি অতিরিক্ত ঘর ভ্রমণ করতে পারে',
    rhinoChargePost: 'ধ্বংসাত্মক চলাচল এবং ধরার সম্ভাবনার দিকে পরিচালিত করে',
    rhinoTrample: 'গন্ডার তার ভ্রমণ পথের সমস্ত গুটি পদদলিত দিয়ে ধরে',
    rhinoTramplePost: 'একটি অজ্ঞান ছাগল গুটি সহ',
    rhinoLane: 'গন্ডার কৌশলগত লেনিং খেলার অনুমতি দিয়ে অন্য মিত্র গুটির সাথে জায়গা পরিবর্তন করতে পারে',
    rhinoLanePost: 'কিন্তু শুধুমাত্র যদি গন্ডার এবং মিত্র গুটি উভয়ই সরেনি',

    // Snake
    snakeMovement: 'সাপ যেকোনো সরল রেখায় ২ ঘর সরতে পারে',
    snakeMovementPost: 'সাপ ঠিক ২ ঘর সরে যদি না দেয়াল বা বন্ধু গুটি দ্বারা বাধাপ্রাপ্ত হয়',
    snakeMoveBlocks: 'যখন দেয়াল বা গুটি দ্বারা বাধাপ্রাপ্ত হয় যা এটি ধরতে পারে না, তখন সাপের চলাচল ১ ঘরে সংক্ষিপ্ত হয়',
    snakeMoveBlocksPost: 'এটি এখনও দুটি ঘর সরতে পারে এমনকি যদি একটি মধ্যবর্তী গুটি থাকে',
    snakeStrike: 'যদি একটি শত্রু প্রাণী থাকে তবে সাপ ৩ ঘর সামনে আঘাত করতে পারে',
    snakeStrikePost: 'যতক্ষণ না কোনো মধ্যবর্তী গুটি তার পথ বাধা না দেয়',
    snakeShedskin: 'প্রতি খেলায় একবার, সাপ তার খোলস ফেলতে এবং প্রথম র‍্যাঙ্কে ফিরে যেতে পারে যদি ঘরটি খালি থাকে',
    snakeShedskinPost: 'এই পুনর্জন্ম সাপকে প্রতি খেলায় একটি অতিরিক্ত জীবন দেয়',

    // Tree
    treeMovement: 'গাছ একটি ঘর সামনে বা তার র‍্যাঙ্কের যেকোনো ঘরে পাশ থেকে পাশে সরতে পারে',
    treeMovementPost: 'যতক্ষণ না তার পথ বাধাপ্রাপ্ত না হয়',
    treeHouse: 'গাছ অন্যান্য গুটি আশ্রয় দিতে পারে, তাদের শত্রুদের থেকে রক্ষা করে যারা গাছে উঠতে পারে না। হয়তো গুটি ভালুক, সারস, ব্যাঙ, ছত্রাক, ছাগল, বানর, অক্টোপাস এবং সাপের মতো আরোহণ করতে পারে',
    treeHousePost: 'যখন একটি গুটি যা গাছে উঠতে পারে আক্রমণ করে, তখন এটি শুধুমাত্র আশ্রিত গুটি ধরে, গাছকে রক্ষা করে',
    treeTrample: 'গাছ গন্ডারের মতো, যখন এটি সরে তখন একটি ঘরের সমস্ত গুটি ধরে',
    treeTramplePost: 'এটি একটি অজ্ঞান ছাগল অন্তর্ভুক্ত করে',
    treePlant: 'গাছ একটি উদ্ভিদ, প্রাণী নয়, তাই এটি বেশ কয়েকটি প্রভাবের প্রতিরোধী',
    treePlantPost: 'যেমন বিষ, জম্বিফিকেশন, জড়ানো এবং ভাইরাস সংক্রমণ!',

    // Virus
    virusMovement: 'ভাইরাস শুধুমাত্র প্রাণী দ্বারা দখলকৃত ঘরে সরতে পারে, যা দুই ঘর দূরে',
    virusMoveBlocks: 'যদি এটি একটি দেয়ালের পাশে থাকে তবে ভাইরাস শুধুমাত্র এক ঘর সরতে পারে',
    virusCaptureHost: 'যখন ভাইরাস যেকোনো প্রাণী গুটিতে (ভিতরে) অবতরণ করে, তখন এটি কেবল তাদের সংক্রমিত করে, তারা এখনও সংক্রমিত থাকাকালীন নিয়মিত খেলা চালিয়ে যেতে পারে',
    virusCaptureHostPost: 'ভাইরাস শুধুমাত্র গুটি ধরে যখন এটি সংক্রমিত হোস্ট ছেড়ে যায়',
    virusContagion: 'ভাইরাস একক পালায় একাধিক হোস্ট সংক্রমিত করে দ্রুত ছড়িয়ে পড়তে পারে',
    virusContagionPost: 'কন্ট্যাজিয়ন ভাইরাসকে প্রতি পালায় যতগুলি আইনি চাল চায় ততগুলি করতে অনুমতি দেয়',

    // Wolf
    wolfMovement: 'নেকড়ে দাবার ঘোড়ার মতো L আকারে সরতে পারে',
    wolfMovementPost: 'এটি অন্য কোনো গুটি দ্বারা বাধাপ্রাপ্ত হয় না',
    wolfLoneWolf: 'নেকড়ে',
    wolfLoneWolfPost: 'নেকড়ে নিজেকে একাকী বিবেচনা করে যখন এটি এখনও একটি অজ্ঞান ছাগল বা ভাইরাস মিত্র আছে',
  },

  // Tutorials
  tutorials: {
    dragToExploreMobile: '👆 অন্বেষণ করতে টেনে আনুন • জুম করতে চিমটি দিন',
    dragToExploreDesktop: '🖱️ অন্বেষণ করতে টেনে আনুন • জুম করতে স্ক্রল করুন',
    previousConstellation: 'Previous constellation',
    nextConstellation: 'Next constellation',
    lockedNextHint: 'Complete at least 3 {constellation} tutorials to move to the next constellation',
    lockedStateLabel: 'Star Path',
    freeStateLabel: 'Free Roam',
    clickToFreeRoam: 'Click to free roam',
    clickForStarPath: 'Click for Star Path',
    // Tutorial popups
    failed: 'FAILED!',
    success: 'SUCCESS!',
    failedDefaultMessage: "Don't give up! Try a different approach.",
    superMessage: 'Perfect! You achieved Super completion!',
    passMessage: 'Well done! Tutorial completed!',
    tryAgain: 'Try Again',
    back: 'পেছনে',
    next: 'পরবর্তী',
    backToDev: 'Back to Dev',
    backToTutorials: 'Back to Tutorials',
    continue: 'Continue',
    close: 'Close',
  },

  // Sandbox
  sandbox: {
    title: 'স্যান্ডবক্স',
    description: 'পরীক্ষা এবং অনুশীলন',
    mode: 'মোড:',
    modeValue: 'স্যান্ডবক্স',
    status: 'অবস্থা:',
    statusReady: 'প্রস্তুত',
    clearBoard: 'বোর্ড পরিষ্কার করুন',
  },

  // Multiplayer
  multiplayer: {
    title: 'মাল্টিপ্লেয়ার',
    description: 'আপনার ম্যাচ খুঁজুন এবং প্রতিদ্বন্দ্বিতা করুন!',
    // Rematch
    rematchRequest: 'Rematch Request',
    rematchMessage: '{opponent} wants to play again!',

    // Placement matches
    placementMatches: 'প্লেসমেন্ট ম্যাচ',
    matchProgress: 'ম্যাচের অগ্রগতি',
    gamesCompleted: '{games} / ১০টি খেলা সম্পন্ন',
    estimatedFinalRating: 'আনুমানিক চূড়ান্ত রেটিং',
    startingRating: 'শুরুর রেটিং',
    matchesRemaining: '{matches}টি ম্যাচ বাকি',
    findPlacementMatch: 'প্লেসমেন্ট ম্যাচ খুঁজুন',

    // Matchmaking modes
    findMatch: 'ম্যাচ খুঁজুন',
    competitive: 'প্রতিযোগিতামূলক',
    competitiveDesc: 'আপনার র‍্যাঙ্কিংয়ের কাছাকাছি প্রতিপক্ষ খুঁজুন',
    quick: 'দ্রুত',
    quickDesc: 'দ্রুত প্রতিযোগিতামূলক ম্যাচ খুঁজুন',
    casual: 'নৈমিত্তিক',
    casualDesc: 'র‍্যাঙ্কবিহীন - মজার জন্য খেলুন!',
    placement: 'প্লেসমেন্ট',
    placementDesc: 'র‍্যাঙ্ক পেতে ১০টি ম্যাচ সম্পূর্ণ করুন',
    startSearch: 'অনুসন্ধান শুরু করুন',

    // Searching
    searching: 'অনুসন্ধান করা হচ্ছে...',
    mode: 'মোড:',
    inQueue: 'সারিতে:',
    players: 'খেলোয়াড়',
    playersPlural: 'খেলোয়াড়রা',
    cancelSearch: 'অনুসন্ধান বাতিল করুন',

    // Game info
    status: 'অবস্থা:',
    ready: 'প্রস্তুত',
    selectingKing: 'রাজা নির্বাচন করা হচ্ছে',
    placingPieces: 'গুটি স্থাপন করা হচ্ছে',
    playing: 'খেলা হচ্ছে',
    gameType: 'খেলার ধরন:',
    opponent: 'প্রতিপক্ষ:',
    opponentElo: 'প্রতিপক্ষের ELO:',
    unranked: 'র‍্যাঙ্কবিহীন',

    // Piece placement
    dragPieces: 'বোর্ডে গুটি টেনে আনুন',
    lightPieces: 'হালকা গুটি (আপনি)',
    darkPieces: 'গাঢ় গুটি (আপনি)',

    // Waiting states
    waitingForOpponent: 'প্রতিপক্ষের জন্য অপেক্ষা করা হচ্ছে...',
    waitingForKing: 'প্রতিপক্ষ তাদের রাজা নির্বাচনের জন্য অপেক্ষা করা হচ্ছে...',

    // Warnings
    invalidPlacement: 'অবৈধ স্থাপনা',
    lightTurn: 'এটা হালকা খেলোয়াড়ের পালা!',
    darkTurn: 'এটা গাঢ় খেলোয়াড়ের পালা!',
    onlyLightPieces: 'আপনি শুধুমাত্র হালকা গুটি স্থাপন করতে পারেন!',
    onlyDarkPieces: 'আপনি শুধুমাত্র গাঢ় গুটি স্থাপন করতে পারেন!',
    mustPlaceOnRow: '{color} গুটি অবশ্যই {row} সারিতে স্থাপন করতে হবে!',

    // Chat
    chat: 'চ্যাট',
    typeMessage: 'একটি বার্তা টাইপ করুন...',
    send: 'পাঠান',
  },

  // Main Page
  mainPage: {
    title: 'প্রাণী দাবা',
    subtitle: 'মানুষের জন্য একটি খেলা',
    playersOnline: 'বর্তমানে অনলাইন খেলোয়াড়',
    placement: 'প্লেসমেন্ট',
    placementProgress: 'প্লেসমেন্ট',
    challengeAI: 'AI চ্যালেঞ্জ',
    multiplayer: 'মাল্টিপ্লেয়ার',
    sandbox: 'স্যান্ডবক্স',
    tutorials: 'টিউটোরিয়াল',
    shop: 'দোকান',
    collection: 'সংগ্রহ',
    history: 'ইতিহাস',
    analytics: 'বিশ্লেষণ',
    courses: 'কোর্স',
    upgradeAccount: 'অ্যাকাউন্ট আপগ্রেড করুন',
    signIn: 'সাইন ইন',
    playAsGuest: 'অতিথি হিসাবে খেলুন',
    welcomeBack: 'আবার স্বাগতম! আপনি সাধারণত খেলেন যেভাবে',

    // Learn the Pieces section
    learnThePieces: 'গুটি শিখুন',

    // Learn the Rules section
    learnTheRules: 'নিয়ম শিখুন',
    premiseTitle: 'ভিত্তি',
    premiseText: 'রাশিচক্র একটি দাবা বিকল্প যা ১৩টি গুটির একটি রোস্টার থেকে একটি লুকানো রাজা সহ, একটি অনন্য রোস্টার নির্বাচন করুন এবং তারপর ৫ বাই ৮ বোর্ডে তাদের পরাজিত করতে আপনার প্রতিপক্ষকে ব্লাফ করুন',
    selectionTitle: 'নির্বাচন',
    selectionText: 'একটি খেলা শুরু করতে, গোপনে আপনার রাজা চয়ন করুন, তারপর ৫০০ বিলিয়নেরও বেশি প্রাথমিক অবস্থার একটি তৈরি করতে আপনার প্রতিপক্ষের সাথে পর্যায়ক্রমে আপনার ৫টি গুটি স্থাপন করুন।',
    objectiveTitle: 'উদ্দেশ্য',
    objectiveText: 'হয় আপনার প্রতিপক্ষকে পড়ুন তাদের গোপন রাজা ধরতে বা বিজয় নিশ্চিত করতে বোর্ড জুড়ে আপনার রাজা দৌড়ান!',
    competeTitle: 'প্রতিদ্বন্দ্বিতা করুন',
    competeText: 'মই-তে আপনার দক্ষতা পরীক্ষা করুন, নতুন ব্যক্তিগত কৌশল এবং কৌশল বিকাশ করুন, সেরাদের মোকাবেলা করতে র‍্যাঙ্ক আপ করুন!',
    fullRulesButton: 'সম্পূর্ণ অফিসিয়াল নিয়মের জন্য এখানে ক্লিক করুন',

    // FAQ section
    faqTitle: 'সচরাচর জিজ্ঞাসিত প্রশ্ন',
    faqQuestion1: 'রাশিচক্র দাবার পিছনে ধারণা কী?',
    faqAnswer1: 'রাশিচক্র দাবা প্রাথমিকভাবে ববি ফিশারের চেস৯৬০ তৈরির অনুপ্রেরণা সম্পর্কে তার কথা দ্বারা অনুপ্রাণিত হয়েছিল, আমরা মুখস্থ মুখস্থকরণের বিরুদ্ধে লড়াই এবং অকল্পনীয় গভীরতায় মানুষের অন্তর্দৃষ্টি উদযাপনের ধারণা প্রসারিত করতে চেয়েছিলাম!',
    faqQuestion2: 'কেন আমাদের একটি দাবা বিকল্প প্রয়োজন',
    faqAnswer2: 'আমাদের প্রয়োজন নেই! রাশিচক্র দাবা খেলা থেকে মানুষকে সরিয়ে দিতে চায় না! এটি তার নিজস্ব শক্তি এবং দুর্বলতা সহ একটি ভিন্ন বিকল্প, আমরা আশা করি আপনি এটি নিয়ে কিছু মজা পাবেন এবং উপন্যাস খেলাকে প্রাণবন্ত করতে এই খেলাটি মানিয়ে নিতে আমাদের সাহায্য করবেন',
    faqQuestion3: 'রাশিচক্র দাবায় কীভাবে জিতবেন?',
    faqAnswer3: 'জেতার তিনটি উপায় আছে: আপনার প্রতিপক্ষের লুকানো রাজা গুটি ধরুন, বোর্ডের বিপরীত দিকে আপনার নিজের রাজাকে দৌড়ান, বা সময় নিয়ন্ত্রণ সহ একটি ম্যাচে, আপনার প্রতিপক্ষের সময় শেষ হয়ে যায়',
    faqQuestion4: 'এটি কি একটি FAQ?',
    faqAnswer4: 'হ্যাঁ, আপনি FAQ-তে তালিকাভুক্ত যেকোনো প্রশ্ন দেখতে পারেন এবং যদি আপনি আরও কিছু বিশদ চান, আপনি প্রশ্নগুলিতে ক্লিক করতে পারেন এবং তারপর নিম্নলিখিত বিশদগুলি পড়তে পারেন, যেমন এই বিশদগুলি আপনি এখন পড়ছেন',
    faqQuestion5: 'একটি সাধারণ খেলা কতক্ষণ স্থায়ী হয়?',
    faqAnswer5: 'প্রতিটি খেলা ব্যাপকভাবে পৃথক! কিছু খেলা ২ চালে শেষ হয় এবং কিছু ৩০ মিনিট নিতে পারে, আমরা সাধারণত তাদের ৫-১৫ মিনিটের চিহ্নে খুঁজে পাই!',
    faqQuestion6: 'কেউ যদি কোনো আইনি চাল করতে না পারে তাহলে কী হবে?',
    faqAnswer6: 'যদি একজন খেলোয়াড় কোনো আইনি চাল করতে না পারে (স্থবিরতা), খেলা ড্রতে শেষ হয়। খেলা পুনরাবৃত্তির মাধ্যমে (একই বোর্ড অবস্থা ৩ বার) বা খেলোয়াড়দের মধ্যে পারস্পরিক চুক্তির মাধ্যমেও ড্রতে শেষ হতে পারে!',

    // About section
    aboutButton: 'সম্পর্কে',
    privacyPolicy: 'গোপনীয়তা নীতি',
    developerInterface: 'ডেভেলপার ইন্টারফেস',
  },

  // About Modal
  about: {
    title: 'রাশিচক্র সম্পর্কে',
    paragraph1: 'রাশিচক্র একটি দাবা-সদৃশ বোর্ড গেম যা LoL এবং DotA-এর মতো খেলা থেকে গুটি নির্বাচনের উপাদান, পোকার বা সামাজিক কর্তন খেলা থেকে ব্লাফিং মেকানিক্স একত্রিত করে।',
    paragraph2: 'খেলার প্রথম সংস্করণগুলি ২০১৪ সালে শ্যাডো চেস নামে তৈরি করা হয়েছিল। ২০১৮ সালে এটি আজকের মতো হওয়ার জন্য পুনরায় ডিজাইন করা হয়েছিল, যা সুষম কিন্তু অনন্য চলাচল প্যাটার্ন এবং ক্ষমতা সহ মজার গুটির একটি রোস্টার জড়িত।',
    paragraph3: 'আমাদের দৃষ্টিভঙ্গি হল খেলাকে সতেজ রাখার এবং উপন্যাস খেলা উৎসাহিত করার প্রচেষ্টায় খেলাকে বিকশিত করতে সমস্ত ব্যবহারকারীর গেমপ্লে ডেটা রেকর্ড করা।',
    paragraph4: 'রাশিচক্রের বিশাল অনুসন্ধান স্থান, লুকানো তথ্য এবং খোলার বোর্ড অবস্থানের সাথে আমরা AI আধিপত্য রোধ করতে এবং রাশিচক্রকে মানুষের জন্য একটি খেলা রাখার আশা করি!',
  },

  // Privacy Policy
  privacy: {
    title: 'গোপনীয়তা নীতি',
    lastUpdated: 'সর্বশেষ আপডেট',

    introduction: {
      title: 'ভূমিকা',
      p1: 'রাশিচক্র দাবায় স্বাগতম ("আমরা", "আমাদের" বা "আমরা")। আমরা আপনার গোপনীয়তা রক্ষা করতে এবং আপনাকে একটি নিরাপদ এবং উপভোগ্য গেমিং অভিজ্ঞতা নিশ্চিত করতে প্রতিশ্রুতিবদ্ধ। এই গোপনীয়তা নীতি ব্যাখ্যা করে কীভাবে আমরা আপনার তথ্য সংগ্রহ, ব্যবহার, প্রকাশ এবং সুরক্ষিত করি যখন আপনি আমাদের ওয়েবসাইট এবং গেম ব্যবহার করেন।',
      p2: 'রাশিচক্র দাবা ব্যবহার করে, আপনি এই নীতি অনুসারে তথ্য সংগ্রহ এবং ব্যবহারে সম্মত হন। যদি আপনি আমাদের নীতি এবং অনুশীলনের সাথে একমত না হন, অনুগ্রহ করে আমাদের পরিষেবা ব্যবহার করবেন না।',
      contact: 'আমাদের সাথে যোগাযোগ করুন:',
    },

    infoCollect: {
      title: 'আমরা যে তথ্য সংগ্রহ করি',
      accountInfo: {
        title: '১. অ্যাকাউন্ট তথ্য',
        item1: 'ইমেল ঠিকানা: অ্যাকাউন্ট তৈরি এবং যোগাযোগের জন্য প্রয়োজনীয়',
        item2: 'ব্যবহারকারীর নাম: আপনার নির্বাচিত প্রদর্শন নাম',
        item3: 'পাসওয়ার্ড: এনক্রিপ্ট করা এবং নিরাপদে সংরক্ষিত',
      },
      gameData: {
        title: '২. খেলার ডেটা',
        item1: 'খেলার পরিসংখ্যান: জয়, পরাজয়, ELO রেটিং, প্লেসমেন্ট ম্যাচ অগ্রগতি',
        item2: 'গেমপ্লে ডেটা: গুটি নির্বাচন, করা চাল, ব্যবহৃত কৌশল',
        item3: 'ম্যাচ ইতিহাস: খেলা খেলার রেকর্ড, মুখোমুখি প্রতিপক্ষ',
        item4: 'ইন-গেম ক্রয়: কসমেটিক আইটেম এবং প্রিমিয়াম সদস্যতা অবস্থা',
      },
      technicalData: {
        title: '৩. প্রযুক্তিগত ডেটা',
        item1: 'ডিভাইস তথ্য: ব্রাউজার প্রকার, অপারেটিং সিস্টেম',
        item2: 'ব্যবহার ডেটা: পরিদর্শিত পৃষ্ঠা, ব্যয় করা সময়, ব্যবহৃত বৈশিষ্ট্য',
        item3: 'স্থানীয় সঞ্চয়স্থান: ভাষা পছন্দ, UI সেটিংস, অস্থায়ী খেলার অবস্থা',
      },
    },

    children: {
      title: 'শিশুদের গোপনীয়তা (COPPA সম্মতি)',
      p1: 'রাশিচক্র দাবা পরিবার-বান্ধব এবং শিশুদের সহ সব বয়সের খেলোয়াড়দের জন্য উপযুক্ত হওয়ার জন্য ডিজাইন করা হয়েছে। আমরা শিশুদের অনলাইন গোপনীয়তা সুরক্ষা আইন (COPPA) মেনে চলার জন্য বিশেষ যত্ন নিই।',
      p2: '১৩ বছরের কম বয়সী ব্যবহারকারীদের জন্য: আমরা সুপারিশ করি যে শিশুরা আমাদের অতিথি খেলার মোড ব্যবহার করুক, যার জন্য অ্যাকাউন্ট তৈরি বা ডেটা সংগ্রহের প্রয়োজন নেই। অতিথি অ্যাকাউন্টগুলির পাঠ্য চ্যাট বৈশিষ্ট্যগুলিতে অ্যাক্সেস নেই, নিশ্চিত করে যে শিশুরা বিস্তৃত ইন্টারনেটের সাথে যোগাযোগের সংস্পর্শে আসে না। যদি একটি শিশু একটি অ্যাকাউন্ট তৈরি করে, তবে আমরা কোনো ব্যক্তিগত তথ্য সংগ্রহ করার আগে অভিভাবকের সম্মতি প্রয়োজন।',
      p3: 'আমরা যাচাইকৃত পিতামাতার সম্মতি ছাড়া ১৩ বছরের কম বয়সী শিশুদের কাছ থেকে জেনেশুনে ব্যক্তিগত তথ্য সংগ্রহ, ব্যবহার বা ভাগ করি না।',
      p4: 'চ্যাট নিরাপত্তা: সমস্ত অতিথি/অস্থায়ী অ্যাকাউন্টের জন্য পাঠ্য চ্যাট স্বয়ংক্রিয়ভাবে নিষ্ক্রিয়। স্ট্যান্ডার্ড অ্যাকাউন্ট হোল্ডারদের যে কোনো সময় তাদের অ্যাকাউন্ট সেটিংসে চ্যাট কার্যকারিতা নিষ্ক্রিয় করার বিকল্প রয়েছে।',
      parentalRights: 'পিতামাতার অধিকার আছে:',
      right1: 'তাদের সন্তানের ব্যক্তিগত তথ্য পর্যালোচনা করুন',
      right2: 'তাদের সন্তানের ডেটা মুছে ফেলার অনুরোধ করুন',
      right3: 'তাদের সন্তানের তথ্যের আরও সংগ্রহ বা ব্যবহার প্রত্যাখ্যান করুন',
      contactUs: 'এই অধিকার প্রয়োগ করতে বা আপনি বিশ্বাস করেন যে আপনার সন্তান আমাদের ব্যক্তিগত তথ্য প্রদান করেছে, অবিলম্বে contact@zodiac-chess.com এ আমাদের সাথে যোগাযোগ করুন',
    },

    howWeUse: {
      title: 'আমরা কীভাবে আপনার তথ্য ব্যবহার করি',
      item1: 'আমাদের খেলা পরিষেবা প্রদান এবং উন্নত করুন',
      item2: 'দক্ষতা স্তরের উপর ভিত্তি করে আপনাকে উপযুক্ত প্রতিপক্ষের সাথে মিলান',
      item3: 'আপনার অগ্রগতি, পরিসংখ্যান এবং অর্জন ট্র্যাক করুন',
      item4: 'প্রিমিয়াম সদস্যতা এবং কসমেটিক আইটেমের জন্য পেমেন্ট প্রক্রিয়া করুন',
      item5: 'গুরুত্বপূর্ণ পরিষেবা ঘোষণা এবং আপডেট পাঠান',
      item6: 'খেলা ভারসাম্য এবং বৈশিষ্ট্য উন্নত করতে গেমপ্লে ডেটা বিশ্লেষণ করুন',
    },

    thirdParty: {
      title: 'তৃতীয় পক্ষের পরিষেবা',
      firebase: {
        title: 'Firebase (Google)',
        description: 'আমরা প্রমাণীকরণ, ডাটাবেস সঞ্চয়স্থান এবং মাল্টিপ্লেয়ার কার্যকারিতার জন্য Firebase ব্যবহার করি। Firebase তাদের গোপনীয়তা নীতিতে বর্ণিত কিছু ডেটা সংগ্রহ করতে পারে।',
      },
      stripe: {
        title: 'Stripe',
        description: 'আমরা প্রিমিয়াম সদস্যতা এবং ইন-অ্যাপ ক্রয়ের জন্য পেমেন্ট প্রক্রিয়া করতে Stripe ব্যবহার করি। Stripe সমস্ত পেমেন্ট কার্ড তথ্য পরিচালনা করে - আমরা কখনও আপনার সম্পূর্ণ পেমেন্ট বিবরণ দেখি বা সংরক্ষণ করি না।',
      },
      netlify: {
        title: 'Netlify',
        description: 'আমাদের ওয়েবসাইট Netlify-এ হোস্ট করা হয়েছে, যা IP ঠিকানা এবং অ্যাক্সেস লগের মতো স্ট্যান্ডার্ড ওয়েব হোস্টিং ডেটা সংগ্রহ করতে পারে।',
      },
      adsense: {
        title: 'Google AdSense (ভবিষ্যৎ)',
        description: 'আমরা Google AdSense এর মাধ্যমে বিজ্ঞাপন প্রদর্শন করতে পারি। এই বিজ্ঞাপনগুলি ব্যক্তিগতকরণের জন্য কুকি ব্যবহার করতে পারে। শিশু-নির্দেশিত সামগ্রীর জন্য, আমরা COPPA সম্মতিতে শুধুমাত্র অ-ব্যক্তিগতকৃত বিজ্ঞাপন দেখাব।',
      },
      viewPolicy: 'তাদের গোপনীয়তা নীতি দেখুন',
    },

    cookies: {
      title: 'কুকি এবং স্থানীয় সঞ্চয়স্থান',
      description: 'আমরা আপনার অভিজ্ঞতা বাড়ানোর জন্য ব্রাউজার স্থানীয় সঞ্চয়স্থান (কুকির মতো) ব্যবহার করি:',
      item1: 'ভাষা পছন্দ: আপনার নির্বাচিত ভাষা মনে রাখুন',
      item2: 'অ্যাকাউন্ট সেশন: আপনাকে লগ ইন রাখুন (Firebase এর সাথে কাজ করে)',
      item3: 'খেলার সেটিংস: আপনার UI পছন্দ এবং স্যান্ডবক্স সেটআপ মনে রাখুন',
      item4: 'বিজ্ঞাপন কুকি: যদি আপনি সম্মতি দেন, তৃতীয় পক্ষের বিজ্ঞাপন পরিষেবাগুলি বিজ্ঞাপন ব্যক্তিগতকরণের জন্য কুকি ব্যবহার করতে পারে',
    },

    security: {
      title: 'ডেটা নিরাপত্তা',
      p1: 'আমরা আপনার তথ্য রক্ষা করতে উপযুক্ত নিরাপত্তা ব্যবস্থা বাস্তবায়ন করি:',
      item1: 'পাসওয়ার্ড এনক্রিপশন: সমস্ত পাসওয়ার্ড শিল্প-মান পদ্ধতি ব্যবহার করে এনক্রিপ্ট করা হয়',
      item2: 'নিরাপদ সংযোগ: সমস্ত ডেটা ট্রান্সমিশনের জন্য HTTPS এনক্রিপশন',
      item3: 'Firebase নিরাপত্তা নিয়ম: কঠোর ডাটাবেস অ্যাক্সেস নিয়ন্ত্রণ',
      p2: 'তবে, ইন্টারনেটে ট্রান্সমিশনের কোনো পদ্ধতি ১০০% নিরাপদ নয়। যদিও আমরা আপনার ডেটা রক্ষা করতে চেষ্টা করি, আমরা সম্পূর্ণ নিরাপত্তা গ্যারান্টি দিতে পারি না।',
    },

    retention: {
      title: 'ডেটা ধারণ',
      p1: 'আমরা নিম্নরূপ আপনার ডেটা ধরে রাখি:',
      item1: 'সক্রিয় অ্যাকাউন্ট: আপনার অ্যাকাউন্ট সক্রিয় থাকাকালীন ডেটা ধরে রাখা হয়',
      item2: 'নিষ্ক্রিয় অ্যাকাউন্ট: যদি আপনার অ্যাকাউন্ট ১০ বছরের জন্য নিষ্ক্রিয় থাকে, আমরা আপনার ডেটা মুছে ফেলতে পারি',
    },

    rights: {
      title: 'আপনার গোপনীয়তা অধিকার',
      description: 'আপনার অবস্থানের উপর নির্ভর করে, আপনার নিম্নলিখিত অধিকার থাকতে পারে:',
      access: {
        title: 'অ্যাক্সেস:',
        description: 'আপনার ব্যক্তিগত ডেটার একটি অনুলিপি অনুরোধ করুন',
      },
      correction: {
        title: 'সংশোধন:',
        description: 'আপনার ডেটা সংশোধন অনুরোধ করুন',
      },
      deletion: {
        title: 'মুছে ফেলা:',
        description: 'আপনার অ্যাকাউন্ট এবং ডেটা মুছে ফেলার অনুরোধ করুন',
      },
      portability: {
        title: 'ডেটা পোর্টেবিলিটি:',
        description: 'একটি পোর্টেবল ফর্ম্যাটে আপনার ডেটা অনুরোধ করুন',
      },
      optOut: {
        title: 'অপ্ট-আউট:',
        description: 'বিপণন যোগাযোগ থেকে অপ্ট-আউট করুন',
      },
      contact: 'এই অধিকারগুলির যেকোনো একটি প্রয়োগ করতে, অনুগ্রহ করে contact@zodiac-chess.com এ আমাদের সাথে যোগাযোগ করুন',
    },

    international: {
      title: 'আন্তর্জাতিক ব্যবহারকারী',
      p1: 'রাশিচক্র দাবা নিউজিল্যান্ড থেকে পরিচালিত হয়। আপনি যদি নিউজিল্যান্ডের বাইরে থেকে আমাদের পরিষেবা অ্যাক্সেস করেন, অনুগ্রহ করে সচেতন থাকুন যে আপনার তথ্য নিউজিল্যান্ড এবং অন্যান্য দেশে স্থানান্তরিত, সংরক্ষিত এবং প্রক্রিয়া করা হতে পারে যেখানে আমাদের পরিষেবা প্রদানকারীরা কাজ করে।',
      p2: 'আমাদের পরিষেবা ব্যবহার করে, আপনি আপনার আবাসিক দেশের বাইরের দেশগুলিতে আপনার তথ্য স্থানান্তরে সম্মতি দেন, যেগুলির ভিন্ন ডেটা সুরক্ষা আইন থাকতে পারে।',
    },

    changes: {
      title: 'এই গোপনীয়তা নীতিতে পরিবর্তন',
      description: 'আমরা সময়ে সময়ে এই গোপনীয়তা নীতি আপডেট করতে পারি। আমরা এই পৃষ্ঠায় নতুন গোপনীয়তা নীতি পোস্ট করে এবং "সর্বশেষ আপডেট" তারিখ আপডেট করে যে কোনো পরিবর্তন সম্পর্কে আপনাকে অবহিত করব। উল্লেখযোগ্য পরিবর্তনগুলি ইমেল বা আমাদের ওয়েবসাইটে একটি বিশিষ্ট বিজ্ঞপ্তির মাধ্যমে যোগাযোগ করা হবে।',
    },

    contact: {
      title: 'আমাদের সাথে যোগাযোগ করুন',
      description: 'এই গোপনীয়তা নীতি বা আমাদের ডেটা অনুশীলন সম্পর্কে আপনার যদি কোনো প্রশ্ন, উদ্বেগ বা অনুরোধ থাকে, অনুগ্রহ করে আমাদের সাথে যোগাযোগ করুন:',
      email: 'ইমেল:',
      company: 'কোম্পানি:',
    },

    cookieConsent: {
      title: 'Cookie Consent & Control',
      p1: 'We believe in transparency and giving you control over your data. When you first visit Zodiac Chess, you will be presented with a cookie consent banner that allows you to choose which types of cookies you want to accept.',
      categories: {
        title: 'Cookie Categories',
        necessary: {
          title: 'Necessary Cookies',
          description: ' These cookies are essential for the website to function properly. They enable core features like authentication, game state management, and security. You cannot opt out of these cookies.',
        },
        analytics: {
          title: 'Analytics Cookies',
          description: ' These cookies help us understand how visitors interact with our website by collecting anonymous usage data through Firebase Analytics. This helps us improve the game experience.',
        },
        advertising: {
          title: 'Advertising Cookies',
          description: ' These cookies are used by Google AdSense to display personalized advertisements. Premium members never see ads, regardless of consent settings.',
        },
      },
      control: {
        title: 'How to Control Cookies',
        p1: 'You have several options to manage your cookie preferences:',
        method1: 'Cookie Banner: On your first visit, you can accept all cookies, reject optional cookies, or customize your preferences.',
        method2: 'Browser Settings: Most browsers allow you to refuse or delete cookies through their settings menu.',
        method3: 'Opt-Out Links: For advertising cookies, you can opt out of personalized ads using the links below.',
      },
      optOut: {
        title: 'Opt Out of Personalized Advertising',
        p1: 'If you would like to opt out of personalized advertising from Google and other ad networks, you can use these resources:',
        googleAds: 'Google Ad Settings - Manage Google personalized ads',
        daa: 'Digital Advertising Alliance (DAA) - Opt out of interest-based ads',
        eaa: 'European Interactive Digital Advertising Alliance (EDAA) - EU users opt-out',
      },
      moreInfo: 'For more detailed information about the cookies we use, please visit our',
      cookiePolicyLink: 'Cookie Policy',
    },
  },

  // Cookie Consent Banner
  cookieConsentBanner: {
    title: 'We Value Your Privacy',
    description: 'We use cookies to enhance your experience, analyze site usage, and show personalized ads (for free users only). You can customize your preferences at any time.',
    acceptAll: 'Accept All',
    rejectAll: 'Reject Optional',
    customize: 'Customize',
    savePreferences: 'Save Preferences',
    back: 'Back',
    necessary: 'Necessary Cookies',
    necessaryDesc: 'Required for the site to function. These cannot be disabled.',
    analytics: 'Analytics Cookies',
    analyticsDesc: 'Help us understand how you use the site to improve your experience.',
    advertising: 'Advertising Cookies',
    advertisingDesc: 'Used to show personalized ads (free users only, premium members never see ads).',
    privacyPolicy: 'Privacy Policy',
    cookiePolicy: 'Cookie Policy',
  },

  // Terms of Service
  terms: {
    title: 'সেবার শর্তাবলী',
    lastUpdated: 'সর্বশেষ আপডেট',
    back: 'ফিরে যান',
    viewPrivacyPolicy: 'গোপনীয়তা নীতি দেখুন',
    acknowledgment: 'Zodiac Chess ব্যবহার করে, আপনি স্বীকার করছেন যে আপনি এই সেবার শর্তাবলী পড়েছেন, বুঝেছেন এবং মেনে চলতে সম্মত হয়েছেন।',
    acceptance: {
      title: '১. শর্তাবলী গ্রহণ',
      p1: 'Zodiac Chess ("সেবা") অ্যাক্সেস এবং ব্যবহার করে, আপনি এই সেবার শর্তাবলী মেনে চলতে সম্মত হচ্ছেন। আপনি যদি এই শর্তাবলীতে সম্মত না হন, অনুগ্রহ করে সেবাটি ব্যবহার করবেন না।',
      p2: 'আমরা যেকোনো সময় এই শর্তাবলী পরিবর্তন করার অধিকার সংরক্ষণ করি। পরিবর্তনের পরে সেবার অব্যাহত ব্যবহার পরিবর্তিত শর্তাবলী গ্রহণ হিসাবে গণ্য হবে।',
    },
    description: {
      title: '২. সেবার বিবরণ',
      p1: 'Zodiac Chess হল একটি অনলাইন কৌশলগত বোর্ড গেম যেখানে বিশেষ ক্ষমতাসম্পন্ন অনন্য পশু টুকরা রয়েছে। সেবায় অন্তর্ভুক্ত:',
      feature1: 'AI প্রতিপক্ষের বিরুদ্ধে একক-খেলোয়াড় গেমপ্লে',
      feature2: 'মাল্টিপ্লেয়ার ম্যাচমেকিং এবং প্রতিযোগিতামূলক খেলা',
      feature3: 'ইন্টারেক্টিভ টিউটোরিয়াল এবং শেখার সংস্থান',
      feature4: 'অ্যাকাউন্ট তৈরি এবং অগ্রগতি ট্র্যাকিং',
      feature5: 'ঐচ্ছিক প্রিমিয়াম সাবস্ক্রিপশন বৈশিষ্ট্য',
      feature6: 'কসমেটিক কাস্টমাইজেশন অপশন',
    },
    accounts: {
      title: '৩. ব্যবহারকারী অ্যাকাউন্ট',
      eligibility: {
        title: '৩.১ যোগ্যতা',
        p1: 'অ্যাকাউন্ট তৈরি করতে আপনার বয়স কমপক্ষে ১৩ বছর হতে হবে। ১৩ বছরের কম বয়সী ব্যবহারকারীরা অভিভাবকের তত্ত্বাবধানে গেস্ট প্লে মোড ব্যবহার করতে পারবেন কিন্তু অ্যাকাউন্ট তৈরি করতে পারবেন না।',
      },
      responsibilities: {
        title: '৩.২ অ্যাকাউন্ট নিরাপত্তা',
        p1: 'আপনি দায়ী:',
        item1: 'আপনার পাসওয়ার্ডের গোপনীয়তা বজায় রাখা',
        item2: 'আপনার অ্যাকাউন্টের অধীনে ঘটে যাওয়া সমস্ত কার্যকলাপ',
        item3: 'যেকোনো অননুমোদিত ব্যবহারের বিষয়ে আমাদের অবিলম্বে জানানো',
        p2: 'অননুমোদিত অ্যাকাউন্ট অ্যাক্সেস থেকে উদ্ভূত কোনো ক্ষতির জন্য আমরা দায়ী নই।',
      },
      prohibited: {
        title: '৩.৩ নিষিদ্ধ কার্যকলাপ',
        p1: 'আপনি করতে পারবেন না:',
        item1: 'অন্যদের সাথে আপনার অ্যাকাউন্ট শেয়ার করা',
        item2: 'র‍্যাঙ্কিং ম্যানিপুলেট করতে একাধিক অ্যাকাউন্ট ব্যবহার করা',
        item3: 'গেম খেলতে বট, স্ক্রিপ্ট বা স্বয়ংক্রিয় টুল ব্যবহার করা',
        item4: 'অন্য খেলোয়াড়দের হয়রানি, অপব্যবহার বা হুমকি দেওয়া',
        item5: 'অন্যায় সুবিধার জন্য বাগ বা গ্লিচ কাজে লাগানো',
        item6: 'আমাদের সোর্স কোড রিভার্স ইঞ্জিনিয়ার করা বা অ্যাক্সেস করার চেষ্টা করা',
        p2: 'এই নিয়মগুলি লঙ্ঘনের ফলে অ্যাকাউন্ট সাসপেনশন বা স্থায়ী নিষেধাজ্ঞা হতে পারে।',
      },
    },
    premium: {
      title: '৪. প্রিমিয়াম সাবস্ক্রিপশন',
      billing: {
        title: '৪.১ বিলিং',
        p1: 'প্রিমিয়াম সাবস্ক্রিপশন Stripe এর মাধ্যমে প্রক্রিয়া করা হয়। প্রিমিয়াম সাবস্ক্রিপশন কেনার মাধ্যমে, আপনি বাতিল না করা পর্যন্ত আমাদের আপনার পেমেন্ট পদ্ধতিতে পুনরাবৃত্ত ভিত্তিতে চার্জ করার অনুমতি দিচ্ছেন।',
        p2: 'সাবস্ক্রিপশন ফি হল:',
        item1: 'মাসিক প্ল্যান: আপনার ক্রয়ের তারিখের বার্ষিকীতে মাসিক চার্জ করা হয়',
        item2: 'বার্ষিক প্ল্যান: আপনার ক্রয়ের তারিখের বার্ষিকীতে বার্ষিক চার্জ করা হয়',
        p3: 'সক্রিয় সাবস্ক্রাইবারদের ৩০ দিনের নোটিশে মূল্য পরিবর্তন হতে পারে।',
      },
      cancellation: {
        title: '৪.২ বাতিলকরণ',
        p1: 'আপনি যেকোনো সময় আপনার অ্যাকাউন্ট সেটিংসের মাধ্যমে বা সাপোর্টে যোগাযোগ করে আপনার সাবস্ক্রিপশন বাতিল করতে পারেন। বাতিল আপনার বর্তমান বিলিং পিরিয়ডের শেষে কার্যকর হয়।',
        p2: 'বাতিল করার পরেও আপনি আপনার প্রদত্ত সময়ের শেষ পর্যন্ত প্রিমিয়াম বৈশিষ্ট্যগুলি বজায় রাখবেন।',
      },
      refunds: {
        title: '৪.৩ রিফান্ড',
        p1: 'মাসিক সাবস্ক্রিপশন: আংশিক মাসের জন্য কোনো রিফান্ড নেই। ভবিষ্যতের চার্জ বন্ধ করতে যেকোনো সময় বাতিল করুন।',
        p2: 'বার্ষিক সাবস্ক্রিপশন: ক্রয়ের ৭ দিনের মধ্যে অনুরোধ করলে সম্পূর্ণ রিফান্ড। ৭ দিন পরে, রিফান্ড আমাদের বিবেচনার উপর নির্ভর করে।',
        p3: 'কসমেটিক ক্রয়: সাধারণত অ-ফেরতযোগ্য। ব্যতিক্রমী পরিস্থিতির জন্য সাপোর্টে যোগাযোগ করুন।',
      },
    },
    acceptable: {
      title: '৫. গ্রহণযোগ্য ব্যবহার নীতি',
      p1: 'আপনি সম্মানজনক এবং আইনসম্মত উপায়ে Zodiac Chess ব্যবহার করতে সম্মত হচ্ছেন। নিষিদ্ধ আচরণের মধ্যে রয়েছে:',
      item1: 'প্রতারণা, হ্যাকিং বা গেম মেকানিক্স কাজে লাগানো',
      item2: 'হয়রানি, ঘৃণামূলক বক্তব্য বা বৈষম্যমূলক ভাষা',
      item3: 'স্প্যামিং, বিজ্ঞাপন বা প্রচার',
      item4: 'অনুপযুক্ত বিষয়বস্তু শেয়ার করা (যদি চ্যাট বা ব্যবহারকারী-তৈরি বিষয়বস্তু সক্ষম থাকে)',
      item5: 'অন্য ব্যবহারকারী বা স্টাফ সদস্যদের ছদ্মবেশ ধারণ',
      item6: 'সেবা ব্যাহত বা ক্ষতি করার চেষ্টা',
      p2: 'আমরা লঙ্ঘন তদন্ত করার এবং প্রয়োজনে অ্যাকাউন্ট বাতিল এবং কর্তৃপক্ষের কাছে রিপোর্ট সহ যথাযথ ব্যবস্থা নেওয়ার অধিকার সংরক্ষণ করি।',
    },
    intellectual: {
      title: '৬. মেধা সম্পত্তি অধিকার',
      ownership: {
        title: '৬.১ আমাদের বিষয়বস্তু',
        p1: 'গেম মেকানিক্স, আর্টওয়ার্ক, অ্যানিমেশন, সাউন্ড ইফেক্ট, কোড এবং ডিজাইন সহ কিন্তু এতে সীমাবদ্ধ নয় সমস্ত গেম বিষয়বস্তু Animal Chess Limited বা আমাদের লাইসেন্সদাতাদের মালিকানাধীন।',
        p2: 'আপনাকে শুধুমাত্র ব্যক্তিগত বিনোদনের উদ্দেশ্যে সেবা ব্যবহার করার জন্য একটি সীমিত, অ-একচেটিয়া, অ-হস্তান্তরযোগ্য লাইসেন্স দেওয়া হয়েছে।',
      },
      userContent: {
        title: '৬.২ ব্যবহারকারীর বিষয়বস্তু',
        p1: 'বিষয়বস্তু জমা দিয়ে (যেমন চ্যাট বার্তা, ব্যবহারকারীর নাম বা প্রোফাইল তথ্য), আপনি আমাদের সেবার সাথে সম্পর্কিত সেই বিষয়বস্তু ব্যবহার, প্রদর্শন এবং বিতরণ করার জন্য একটি বিশ্বব্যাপী, রয়্যালটি-মুক্ত লাইসেন্স প্রদান করছেন।',
        p2: 'আপনি প্রতিনিধিত্ব করছেন যে আপনি জমা দেওয়া যেকোনো বিষয়বস্তুর মালিক বা প্রয়োজনীয় অধিকার রয়েছে।',
      },
    },
    disclaimers: {
      title: '৭. দায়িত্ব অস্বীকার এবং দায়বদ্ধতার সীমাবদ্ধতা',
      p1: 'সেবাটি কোনো প্রকার ওয়ারেন্টি ছাড়াই "যেমন আছে" ভিত্তিতে প্রদান করা হয়, প্রকাশ্য বা অন্তর্নিহিত।',
      p2: 'আমরা গ্যারান্টি দিই না যে:',
      item1: 'সেবা নিরবচ্ছিন্ন বা ত্রুটিমুক্ত হবে',
      item2: 'ত্রুটিগুলি সংশোধন করা হবে',
      item3: 'সেবা ভাইরাস বা ক্ষতিকারক উপাদান মুক্ত',
      item4: 'সেবা ব্যবহারের ফলাফল আপনার প্রত্যাশা পূরণ করবে',
      p3: 'আইন দ্বারা অনুমোদিত সর্বোচ্চ পরিমাণে, আমরা দায়ী নই:',
      item5: 'কোনো পরোক্ষ, আনুষঙ্গিক বা পরিণতিমূলক ক্ষতি',
      item6: 'লাভ, ডেটা বা সুনামের ক্ষতি',
      item7: 'সেবা বিঘ্ন বা ডেটা হারানো',
      item8: 'গত ১২ মাসে আপনি আমাদের যে পরিমাণ অর্থ প্রদান করেছেন তার অতিরিক্ত ক্ষতি',
    },
    privacy: {
      title: '৮. গোপনীয়তা',
      p1: 'সেবার আপনার ব্যবহার আমাদের গোপনীয়তা নীতি দ্বারাও নিয়ন্ত্রিত, যা ব্যাখ্যা করে কীভাবে আমরা আপনার ব্যক্তিগত তথ্য সংগ্রহ, ব্যবহার এবং সুরক্ষা করি।',
      p2: 'সেবা ব্যবহার করে, আপনি গোপনীয়তা নীতিতে বর্ণিত আমাদের ডেটা অনুশীলনে সম্মতি দিচ্ছেন।',
    },
    changes: {
      title: '৯. শর্তাবলীতে পরিবর্তন',
      p1: 'আমরা যেকোনো সময় এই সেবার শর্তাবলী পরিবর্তন করার অধিকার সংরক্ষণ করি। আমরা নিম্নলিখিত মাধ্যমে উল্লেখযোগ্য পরিবর্তন সম্পর্কে ব্যবহারকারীদের অবহিত করব:',
      item1: 'নিবন্ধিত ব্যবহারকারীদের ইমেল বিজ্ঞপ্তি',
      item2: 'ওয়েবসাইটে বিশিষ্ট বিজ্ঞপ্তি',
      item3: 'এই পৃষ্ঠার শীর্ষে "সর্বশেষ আপডেট" তারিখ আপডেট',
      p2: 'পরিবর্তনের পরে সেবার আপনার অব্যাহত ব্যবহার পরিবর্তিত শর্তাবলী গ্রহণ গঠন করে।',
    },
    governing: {
      title: '১০. প্রযোজ্য আইন',
      p1: 'এই সেবার শর্তাবলী নিউজিল্যান্ডের আইন দ্বারা নিয়ন্ত্রিত, আইনের দ্বন্দ্ব নীতি নির্বিশেষে।',
      p2: 'এই শর্তাবলী বা সেবার আপনার ব্যবহার থেকে উদ্ভূত যেকোনো বিরোধ নিউজিল্যান্ডের আদালতে সমাধান করা হবে।',
    },
    contact: {
      title: '১১. যোগাযোগের তথ্য',
      p1: 'এই সেবার শর্তাবলী সম্পর্কে প্রশ্ন, উদ্বেগ বা সহায়তার জন্য:',
      email: 'ইমেল:',
      company: 'কোম্পানি:',
      address: 'ঠিকানা:',
    },
    severability: {
      title: '১২. বিচ্ছিন্নতা',
      p1: 'যদি এই শর্তাবলীর কোনো বিধান অপ্রয়োগযোগ্য বা অবৈধ পাওয়া যায়, সেই বিধানটি ন্যূনতম প্রয়োজনীয় পরিমাণে সীমিত বা বাদ দেওয়া হবে, এবং অবশিষ্ট বিধানগুলি সম্পূর্ণ কার্যকর থাকবে।',
    },
  },

  // Cookie Policy
  cookiePolicy: {
    title: 'কুকি নীতি',
    lastUpdated: 'সর্বশেষ আপডেট',
    browserInstructions: {
      chrome: 'সেটিংস → গোপনীয়তা এবং নিরাপত্তা → কুকিজ',
      firefox: 'সেটিংস → গোপনীয়তা এবং নিরাপত্তা → কুকিজ এবং সাইট ডেটা',
      safari: 'পছন্দসমূহ → গোপনীয়তা → কুকিজ এবং ওয়েবসাইট ডেটা',
      edge: 'সেটিংস → গোপনীয়তা, অনুসন্ধান এবং পরিষেবা → কুকিজ',
    },
    cookieTable: {
      name: 'কুকির নাম',
      purpose: 'উদ্দেশ্য',
      duration: 'সময়কাল',
      type: 'ধরন',
    },
    relatedPolicies: {
      title: 'সম্পর্কিত নীতিমালা',
      description: 'আমরা কীভাবে আপনার ডেটা পরিচালনা করি সে সম্পর্কে আরও তথ্যের জন্য, অনুগ্রহ করে দেখুন:',
      privacy: 'গোপনীয়তা নীতি',
      terms: 'সেবার শর্তাবলী',
    },

    introduction: {
      title: 'পরিচিতি',
      p1: 'এই কুকি নীতি ব্যাখ্যা করে কিভাবে Zodiac Chess ("আমরা," "আমাদের") আপনি যখন আমাদের ওয়েবসাইট পরিদর্শন করেন তখন কুকিজ এবং অনুরূপ প্রযুক্তি ব্যবহার করে।',
      p2: 'আমাদের ওয়েবসাইট ব্যবহার করে, আপনি এই নীতি অনুযায়ী আমাদের কুকিজ ব্যবহারে সম্মতি দিচ্ছেন। আপনি যদি সম্মত না হন, অনুগ্রহ করে আপনার ব্রাউজার সেটিংসে কুকিজ নিষ্ক্রিয় করুন বা আমাদের ওয়েবসাইট ব্যবহার করবেন না।',
    },
    what: {
      title: 'কুকিজ কী?',
      p1: 'কুকিজ হল ছোট টেক্সট ফাইল যা আপনি যখন একটি ওয়েবসাইট পরিদর্শন করেন তখন আপনার ডিভাইসে (কম্পিউটার, স্মার্টফোন, ট্যাবলেট) স্থাপিত হয়। ওয়েবসাইটগুলিকে দক্ষতার সাথে কাজ করতে এবং ওয়েবসাইট মালিকদের তথ্য প্রদান করতে এগুলি ব্যাপকভাবে ব্যবহৃত হয়।',
      p2: 'কুকিজ বিভিন্ন উদ্দেশ্যে কাজ করে, যার মধ্যে রয়েছে আপনার পছন্দগুলি মনে রাখা, সাইট ব্যবহার বিশ্লেষণ করা এবং নির্দিষ্ট বৈশিষ্ট্যগুলি সক্ষম করা।',
    },
    types: {
      title: 'আমরা যে ধরনের কুকিজ ব্যবহার করি',
      necessary: {
        title: '১. প্রয়োজনীয় কুকিজ',
        description: 'এই কুকিজগুলি ওয়েবসাইটটি সঠিকভাবে কাজ করার জন্য অপরিহার্য। এই কুকিজ ছাড়া, আপনি যে পরিষেবাগুলি অনুরোধ করেছেন তা প্রদান করা যাবে না।',
        examples: 'উদাহরণ:',
        item1: 'প্রমাণীকরণ কুকিজ - আপনাকে আপনার অ্যাকাউন্টে লগ ইন রাখে',
        item2: 'নিরাপত্তা কুকিজ - প্রতারণামূলক কার্যকলাপ থেকে রক্ষা করে',
        item3: 'সেশন কুকিজ - একটি সেশনের সময় আপনার গেমের অবস্থা বজায় রাখে',
        item4: 'কুকি সম্মতি পছন্দ - আপনার কুকি পছন্দগুলি মনে রাখে',
      },
      analytics: {
        title: '২. বিশ্লেষণ কুকিজ',
        description: 'এই কুকিজগুলি পৃষ্ঠা পরিদর্শন, ব্যয় করা সময় এবং ব্যবহৃত বৈশিষ্ট্যগুলি সম্পর্কে বেনামী তথ্য সংগ্রহ করে দর্শকরা কীভাবে আমাদের ওয়েবসাইটের সাথে ইন্টারঅ্যাক্ট করে তা বুঝতে আমাদের সাহায্য করে।',
        provider: 'প্রদানকারী: Firebase Analytics (Google)',
        purpose: 'উদ্দেশ্য:',
        item1: 'ওয়েবসাইট ট্র্যাফিক এবং ব্যবহারকারীর সম্পৃক্ততা পরিমাপ করা',
        item2: 'জনপ্রিয় বৈশিষ্ট্য এবং পৃষ্ঠাগুলি চিহ্নিত করা',
        item3: 'ব্যবহারকারীর জনসংখ্যা বোঝা (বয়স পরিসীমা, সাধারণ অবস্থান)',
        item4: 'ওয়েবসাইটের কর্মক্ষমতা এবং ব্যবহারকারীর অভিজ্ঞতা উন্নত করা',
      },
      advertising: {
        title: '৩. বিজ্ঞাপন কুকিজ',
        description: 'এই কুকিজগুলি আপনার সাথে প্রাসঙ্গিক বিজ্ঞাপন প্রদর্শন করতে ব্যবহৃত হয়। তারা আপনি কতবার একটি বিজ্ঞাপন দেখেন তা সীমিত করে এবং বিজ্ঞাপন প্রচারণার কার্যকারিতা পরিমাপ করতে সাহায্য করে।',
        provider: 'প্রদানকারী: Google AdSense',
        purpose: 'উদ্দেশ্য:',
        item1: 'আপনার আগ্রহের উপর ভিত্তি করে ব্যক্তিগতকৃত বিজ্ঞাপন দেখানো',
        item2: 'বিজ্ঞাপনের কর্মক্ষমতা এবং সম্পৃক্ততা পরিমাপ করা',
        item3: 'একই বিজ্ঞাপন অনেকবার দেখানো প্রতিরোধ করা',
        note: 'দ্রষ্টব্য: প্রিমিয়াম সদস্যরা কুকি সেটিংস নির্বিশেষে কখনও বিজ্ঞাপন দেখেন না।',
      },
    },
    firstThird: {
      title: 'প্রথম-পক্ষ বনাম তৃতীয়-পক্ষ কুকিজ',
      firstParty: {
        title: 'প্রথম-পক্ষ কুকিজ',
        description: 'এগুলি হল Zodiac Chess দ্বারা সরাসরি সেট করা কুকিজ। আমরা এগুলি অপরিহার্য সাইট কার্যকারিতা, প্রমাণীকরণ এবং আপনার পছন্দগুলি মনে রাখার জন্য ব্যবহার করি।',
      },
      thirdParty: {
        title: 'তৃতীয়-পক্ষ কুকিজ',
        description: 'এগুলি হল আমরা যে বাহ্যিক পরিষেবাগুলি ব্যবহার করি, যেমন Google Analytics এবং Google AdSense দ্বারা সেট করা কুকিজ। তৃতীয়-পক্ষ কুকিজ সেই প্রদানকারীদের গোপনীয়তা নীতির অধীন।',
      },
    },
    specific: {
      title: 'আমরা যে নির্দিষ্ট কুকিজ ব্যবহার করি',
      tableHeader: 'নীচে আমাদের ওয়েবসাইটে ব্যবহৃত কুকিজগুলির একটি বিস্তারিত তালিকা রয়েছে:',
    },
    control: {
      title: 'কুকিজ কীভাবে নিয়ন্ত্রণ করবেন',
      consent: {
        title: '১. কুকি সম্মতি ব্যানার',
        description: 'আপনি যখন প্রথমবার আমাদের ওয়েবসাইট পরিদর্শন করবেন, আপনি একটি কুকি সম্মতি ব্যানার দেখতে পাবেন। আপনি করতে পারেন:',
        item1: 'সব গ্রহণ করুন - সমস্ত কুকিজ অনুমতি দিন (প্রয়োজনীয়, বিশ্লেষণ এবং বিজ্ঞাপন)',
        item2: 'ঐচ্ছিক প্রত্যাখ্যান - শুধুমাত্র প্রয়োজনীয় কুকিজ অনুমতি দিন (কোনো বিশ্লেষণ বা বিজ্ঞাপন নেই)',
        item3: 'কাস্টমাইজ - আপনি ঠিক কোন ধরনের কুকিজ অনুমতি দিতে চান তা চয়ন করুন',
      },
      browser: {
        title: '২. ব্রাউজার সেটিংস',
        description: 'বেশিরভাগ ওয়েব ব্রাউজার আপনাকে তাদের সেটিংসের মাধ্যমে কুকিজ নিয়ন্ত্রণ করতে দেয়। আপনি করতে পারেন:',
        item1: 'সমস্ত কুকিজ ব্লক করুন',
        item2: 'শুধুমাত্র প্রথম-পক্ষ কুকিজ গ্রহণ করুন',
        item3: 'প্রতিটি ব্রাউজিং সেশনের পরে কুকিজ মুছুন',
        item4: 'পৃথক কুকিজ দেখুন এবং মুছুন',
        links: 'জনপ্রিয় ব্রাউজারগুলির জন্য কুকি ব্যবস্থাপনার লিঙ্কগুলি এখানে রয়েছে:',
      },
      optOut: {
        title: '৩. অপ্ট-আউট সরঞ্জাম',
        description: 'বিশেষভাবে বিজ্ঞাপন কুকিজের জন্য, আপনি ব্যক্তিগতকৃত বিজ্ঞাপন থেকে অপ্ট আউট করতে পারেন:',
        googleLink: 'Google বিজ্ঞাপন সেটিংস',
        googleDesc: ' - Google ব্যক্তিগতকৃত বিজ্ঞাপন পরিচালনা করুন',
        daaLink: 'ডিজিটাল অ্যাডভার্টাইজিং অ্যালায়েন্স (DAA)',
        daaDesc: ' - আগ্রহ-ভিত্তিক বিজ্ঞাপন থেকে অপ্ট আউট করুন',
        edaaLink: 'ইউরোপীয় ইন্টারেক্টিভ ডিজিটাল অ্যাডভার্টাইজিং অ্যালায়েন্স (EDAA)',
        edaaDesc: ' - EU-নির্দিষ্ট অপ্ট-আউট সরঞ্জাম',
      },
    },
    impact: {
      title: 'কুকিজ নিষ্ক্রিয় করার প্রভাব',
      p1: 'আপনি যদি কুকিজ নিষ্ক্রিয় বা প্রত্যাখ্যান করেন, অনুগ্রহ করে মনে রাখবেন যে:',
      item1: 'ওয়েবসাইটের কিছু অংশ সঠিকভাবে কাজ নাও করতে পারে',
      item2: 'আপনাকে প্রতিটি পরিদর্শনে আপনার পছন্দগুলি পুনরায় প্রবেশ করতে হতে পারে',
      item3: 'আপনি আপনার অ্যাকাউন্ট থেকে লগ আউট হয়ে যেতে পারেন',
      item4: 'সাইটটি কাজ করার জন্য প্রয়োজনীয় কুকিজ আবশ্যক - সেগুলি নিষ্ক্রিয় করলে আপনি মূল বৈশিষ্ট্যগুলি ব্যবহার করতে পারবেন না',
    },
    updates: {
      title: 'এই কুকি নীতির আপডেট',
      p1: 'আমাদের অনুশীলনে পরিবর্তন প্রতিফলিত করতে বা আইনি, নিয়ন্ত্রক বা পরিচালনাগত কারণে আমরা সময়ে সময়ে এই কুকি নীতি আপডেট করতে পারি।',
      p2: 'এই পৃষ্ঠার শীর্ষে "সর্বশেষ আপডেট" তারিখ আপডেট করে আমরা আপনাকে উল্লেখযোগ্য পরিবর্তন সম্পর্কে অবহিত করব। অনুগ্রহ করে এই নীতি পর্যায়ক্রমে পর্যালোচনা করুন।',
    },
    contact: {
      title: 'আমাদের সাথে যোগাযোগ করুন',
      p1: 'আমাদের কুকিজ ব্যবহার বা এই কুকি নীতি সম্পর্কে আপনার যদি প্রশ্ন থাকে, অনুগ্রহ করে আমাদের সাথে যোগাযোগ করুন:',
      email: 'ইমেইল:',
      company: 'কোম্পানি:',
    },
  },

  // Game
  game: {
    yourTurn: 'Your Turn',
    opponentTurn: "Opponent's Turn",
    victory: 'Victory!',
    defeat: 'Defeat',
    draw: 'Draw',
    resign: 'Resign',
    offerDraw: 'Offer Draw',
  },

  // Game Info
  gameInfo: {
    title: 'Game Info',
    sandboxMode: 'Sandbox Mode',
    lightTurn: "Light's turn",
    darkTurn: "Dark's turn",
    yourTurn: 'Your turn',
    opponentTurn: "Opponent's turn",
    aiThinking: 'AI thinking...',

    // Selection states
    selecting: 'Selecting {piece}',
    observing: 'Observing {piece}',
    selectingZombified: 'Selecting zombified enemy {piece}',
    selectionLocked: 'Selection locked on {piece}',
    selectionLockedPenguin: 'পেঙ্গুইন',

    // Hints
    clickToFaint: 'Click on {piece} to faint',
    clickToRotate: 'Click on the {piece} to rotate',
    clickToInk: 'Click on the {piece} to ink',
    zombifiedWarning: '⚠️ While zombified, {piece} rotates before moving!',

    // Monkey bonus turn
    monkeySwing: 'Monkey completed swing, please move your Monkey to complete bonus turn',
    monkeyConsume: 'Monkey consumed fungi, please move your Monkey to complete bonus turn',

    // Virus bonus turn
    virusInfecting: 'Virus is infecting, continue turn or click on virus to end turn',

    // Penguin bonus turn
    penguinRotate: 'Penguin completed slide - please choose final rotation direction',
    penguinCaptureRotate: 'Penguin completed capture - please choose final rotation direction',
    penguinZombified: 'Zombified Penguin rotated - complete turn with slide/capture (zombification will end)',

    // Capture restrictions
    cannotCapture: '{piece} cannot capture: {targets}',
    cannotInfect: '{piece} cannot infect: {targets}',
    cannotEntangle: '{piece} cannot entangle: {targets}',
    monkeyBearRoll: '{piece} must roll 5-6 to capture enemy {target}',
    cannotBeCapturedBy: '{piece} cannot be captured by: {attackers}',
    monkeyNeedsRoll: '{attacker} needs to roll 5-6 to capture',
  },

  // Piece names
  pieces: {
    Bear: 'ভালুক',
    Crane: 'সারস',
    Frog: 'ব্যাঙ',
    Fungi: 'ছত্রাক',
    Goat: 'ছাগল',
    Monkey: 'বানর',
    Octopus: 'অক্টোপাস',
    Penguin: 'পেঙ্গুইন',
    Rhino: 'গণ্ডার',
    Snake: 'সাপ',
    Tree: 'গাছ',
    Virus: 'ভাইরাস',
    Wolf: 'নেকড়ে',
  },


  // Move Context (piece descriptions)
  moveContext: {
    title: 'Move Context',
    emptyState: 'Select an ability from the left panel to view detailed information.',
  },

  // Challenge AI
  challengeAI: {
    // Title and tagline
    title: 'AI ARENA',
    tagline: 'Pick an AI to Battle or watch AI duke it out!',

    // Player labels
    lightPlayer: 'Light Player',
    darkPlayer: 'Dark Player',
    humanPlayer: 'Human Player',

    // AI Models
    aiGaia: 'Gaia',
    aiSentinel: 'Sentinel',
    aiAlchemist: 'Alchemist',
    aiZenith: 'Zenith',
    aiTrapper: 'Trapper',
    aiHunter: 'Hunter',
    aiWisp: 'Wisp',
    aiCreature: 'Creature',
    aiWeaver: 'Weaver',

    // Time Frames
    timeFast: 'Fast',
    timeStandard: 'Standard',
    timeDeep: 'Deep',

    // Thinking time
    thinkingTime: 'Thinking Time',

    // Info box
    matchupLabel: 'Matchup:',
    statusLabel: 'Status:',
    statusPaused: 'PAUSED',
    statusAIThinking: 'AI Thinking...',
    statusInGame: 'In Game',
    statusReady: 'Ready',
    matchupLocal2P: 'Local 2P',
    matchupPlayerVs: 'Player vs',
    matchupVsPlayer: 'vs Player',

    // Buttons
    startButton: 'Start',
    startRandomButton: 'Start Random',
    newGameButton: 'New Game',
    resumeButton: 'Resume',
    pauseButton: 'Pause',
    pauseQueuedButton: 'Pause (queued...)',
    viewKingsButton: 'View Kings',
    hideKingsButton: 'Hide Kings',
    viewKingsQueuedButton: 'View Kings (queued...)',
    hideKingsQueuedButton: 'Hide Kings (queued...)',
    homeButton: 'Home',
    toggleKingVisibility: 'Toggle king visibility',

    // Warning modal
    invalidPlacement: 'Invalid Placement',
    okButton: 'OK',
    warningLightTurn: "It's Light player's turn to place a piece!",
    warningDarkTurn: "It's Dark player's turn to place a piece!",
    warningLightRow: 'Light pieces must be placed on row 0 (your home row)!',
    warningDarkRow: 'Dark pieces must be placed on row 7 (your home row)!',
    warningOccupied: 'This square is already occupied! Choose an empty square.',
    warningKingRequired: 'You must place your king ({kingType}) before placing your 5th piece!',

    // Piece selection
    dragPieces: 'Drag pieces to the board',
    lightPieces: 'Light Pieces',
    darkPieces: 'Dark Pieces',

    // Mobile
    selectYourKing: 'Select Your King',
    selectPieceToPlace: 'Select Piece to Place',
    moveHistory: 'Move History',
    historyButton: 'History',
    backButton: 'Back',
    lightTurn: "Light's turn",
    darkTurn: "Dark's turn",
  },

  // Donation
  donation: {
    title: 'Support Zodiac Chess',
    supportDevelopment: 'Support Development',
    story1: "Hi! Your support helps me continue improving this unique game! Adding new features, maintaining servers, and keeping Zodiac Chess free for the community.",
    story2: "Even a small donation makes a huge difference and keeps this project alive. Thank you for being part of the Zodiac Chess journey :)",
    selectAmount: 'Choose Amount',
    customAmount: 'Or enter custom amount:',
    total: 'Total:',
    donateButton: 'Donate Now',
    processing: 'Processing...',
    disclaimer: 'Donations support development and server costs. Thank you for your generosity!',
    invalidAmount: 'Please enter a valid amount greater than $0',
    error: 'There was an error processing your donation. Please try again.',
  },

  // Game End Popup
  gameEnd: {
    victory: 'VICTORY!',
    defeat: 'DEFEAT!',
    draw: 'DRAW!',
    wonBy: 'Won by {condition}',
    lostBy: 'Lost by {condition}',
    drawBy: 'Draw by {condition}',
    conditions: {
      kingslayer: 'Kingslayer',
      race: 'Race Victory',
      timeout: 'Timeout',
      threefold: '3x Repetition',
      noMoves: 'No Valid Moves',
      draw: 'Draw',
    },
  },

  // Upgrade Modal
  upgrade: {
    title: 'Upgrade to Premium',
    accountRequired: 'You need to create a permanent account before upgrading to premium.',
    createAccountPrompt: 'Create an account to save your progress and unlock premium features!',
    subtitle: 'Unlock powerful features to enhance your Zodiac Chess experience!',
    features: {
      history: 'Account History',
      historyItem1: 'Store and recall all your previous games',
      historyItem2: 'Replay your old games from anypoint to evaluate strategy',
      historyItem3: 'Use deep analytics to analyse board positions and brilliant move opportunities',
      analytics: 'Analytics',
      analyticsItem1: 'Get access to game stats',
      analyticsItem2: 'Analyse users piece and king selection across tonnes of metrics',
      analyticsItem3: 'Find out what metas are popular and whats working!',
      course: 'Course',
      courseItem1: 'Get access to upto date courses to develop your skill',
      courseItem2: "Learn meta's and concepts from the pro's",
      courseItem3: 'Get tips on your own game play to analyse your own weaknesses',
    },
    createAccount: 'Create Account',
    upgradeNow: 'Upgrade Now',
    cancel: 'Cancel',
  },

  // Premium Modal
  premium: {
    title: 'Premium Feature',
    accessDenied: 'Sorry you do not have a premium account, you do not have access to these features yet!',
  },

  // Stripe Error Page
  stripe: {
    errorTitle: 'Oops! Something Went Wrong',
    errorMessage: "We encountered an issue processing your payment. Don't worry, you haven't been charged.",
    whatHappened: 'What happened?',
    notCompleted: "Your payment wasn't completed. This could be due to:",
    reasons: {
      cancelled: 'Payment was cancelled',
      declined: 'Card was declined',
      connection: 'Connection issue during checkout',
      expired: 'Session expired',
    },
    whatToDo: 'What can you do?',
    actions: {
      tryDifferentCard: 'Try again with a different card',
      tryDifferentCardDesc: 'Use another payment method',
      retryPayment: 'Retry the payment',
      retryPaymentDesc: 'Sometimes a simple retry works',
      checkBank: 'Check with your bank',
      checkBankDesc: 'Ensure your card has sufficient funds',
    },
    tryAgain: 'Try Upgrading Again',
    returnHome: 'Return to Main Page',
    contactSupport: 'Need help? Contact support at support@zodiac-chess.com',
  },


  // How To Play - Learn the Pieces
  howToPlay: {
    // Section titles
    whatIsZodiac: 'What is it about?',
    gameSetup: 'Game Setup',
    basicRules: 'Basic Rules',
    backButton: 'BACK',
    homeButton: 'Home',
    fullRules: 'Full Rules',

    // What is Zodiac section
    whatIs: {
      p1: 'Zodiac is a two player abstract strategy game based off of Chess, Poker and DotA.',
      p2: 'It was created in 2014 as a crude version of itself called "Shadow Chess" based off its central principal of a secret king',
      p3: 'Later in 2018 it was redesigned to involve a roster of novel pieces with unique movement patterns and abilities',
      p4: "Zodiac's goal is to celebrate human intuition and novel play. To drive success toward a players ability to bluff and adapt to unfamiliar situations and create a nuanced set of challenges for the ever growing strength of AI",
      p5: "Another goal of Zodiac is to be a game for humans! With a very large search space for play, hidden information, win obfuscation and a changing roster of pieces over time. Zodiac wants to be a player data driven game that keeps creativity mainstay and staves off AI dominance",
      p6: 'We hope you stick around and see where this journey takes us',
    },

    // Setup section
    setup: {
      p1: "Players play a zodiac version of paper, scissors, rock to see who goes first!",
      p2: 'From there, select a piece to be your "King" your opponent won\'t know which one you have chosen.',
      p3: 'Then pick 5 pieces to play with, they all have different abilities, cohesion, strengths and weaknesses!',
      p4: 'Once you are both done the game will begin.',
      p5: 'Simply click on a piece to see where it can move to or click on any unhighlighted square to deselect the piece.',
      p6: 'Good luck!',
    },

    // Basic Rules section
    rules: {
      intro: 'The game of Zodiac is played by two players on a rectangle board made up of 40 squares (5 by 8).',
      toWinTitle: 'To win:',
      toWin1: 'Capture the opponents King',
      toWin2: '"Race" your King across the board',
      toWin3: 'Have your opponents timer expire',
      toWin4: 'Have your opponent surrender',
      drawTitle: 'A draw occurs',
      draw1: 'When a players king is still uncaptured and they cannot make any legal move, or;',
      draw2: 'The same board position is repeated three times',
    },

    // Piece tutorials
    tutorials: {
      bear: {
        desc1: 'Regular movement - The Bear can move one square in any direction',
        desc2: 'The Bear\'s ability "Savage" allows it to capture any piece regardless of defensive abilities',
        desc3: 'The bear is a "large" piece and a "predator" piece meaning many of the other Zodiacs cannot capture it!',
      },
      crane: {
        desc1: 'The Crane can move 1 or 2 in any straight line for its regular movement',
        desc2: "The Crane cannot capture any 'large' or 'predator' pieces",
      },
      frog: {
        desc1: 'The frog can jump 2 on diagonals for its regular movement, even over other pieces!',
        desc2: "If the frog's regular movement is blocked by a wall or a piece it cannot capture, its regular movement is shortened to 1 square diagonally",
        desc3: "If the frog has yet to make a move in the game, it is on its 'lily pad' and can move to any of the first 3 ranks as a defensive movement",
        desc4: 'If a piece captures a frog, it becomes poisoned and cannot make any move for its next available turn',
        desc5: "The frogs special movement is 'wall climb' if a frog is beside the edge of the board, it can also move one up or down",
      },
      fungi: {
        desc1: 'The Fungi can move one in any direction for its regular movement',
        desc2: "The fungi's ability 'meadow' prevents a tree from moving if it is within one square of the fungi and does not allow a tree to move within one square of the enemy fungi",
        desc3: "When captured the fungi applies a 'zombie' effect to any animal piece that captured it",
        desc4: 'While zombified, the fungi controls the piece for the following turn and acts as the piece, meaning if the fungi was your king, you can still win by race victory or capturing the enemy king within that round',
      },
      goat: {
        desc1: 'The goat can move one in any direction for its regular movement',
        desc2: "The goats ability 'traverse' allows it to hop across linked pieces and then move, it cannot capture any piece on a traverse",
        desc3: "The goat cannot capture any 'predators'",
        desc4: "The goat can use a special ability called 'faint' to make itself appear dead",
        desc5: "While fainted, the goat is unable to be captured by most pieces but cannot move if another piece is 'standing' on it (on the same square)",
      },
      monkey: {
        desc1: 'The monkey can move one in any direction for its regular movement',
        desc2: "The monkey can 'leap' over friendly and enemy pieces like a checkers piece if the formation allows it",
        desc3: 'If the monkey does leap over an enemy piece it must roll a dice to not be captured! One danger point per enemy piece it leaps in a single line',
        desc4: 'The monkey CAN capture a bear if it decides to gamble to attack it, on a 1-4 roll on a six sided dice, the Monkey is captured, on a 5 or 6, the Monkey captures the bear',
        desc5: "The monkey has two abilities - 'swing' and 'consume' on a swing (a leap ending over a tree) the monkey gains an extra movement, on a consume of any fungi, the monkey also gains one extra movement before its turns end",
      },
      octopus: {
        desc1: 'The octopus can move one in any direction for its regular movement',
        desc2: 'The octopus may only capture on orthagonal squares',
        desc3: "The octopus can use its ability 'entangle' on any animal piece on diagonal squares",
        desc4: 'The octopus may make any move AND entangle in one turn',
        desc5: "The octopus has an ability called 'ink' with this ability it can move to any orthagonal square and place 'shadows' on the other 3 orthagonal squares if they are not occupied or off of the board. To the opponent for the round following the 'ink' ability the shadows and real octopus are indistinguishable",
      },
      penguin: {
        desc1: "The penguin has an ability called 'rotate' it is the only piece that has a set direction and may use the 'rotate' move to redirect its direction for its turn",
        desc2: "For the penguins regular movement 'slide' it must move to the furthest point in the direction it is facing and once there, it may use a rotate before its turns end to redirect its direction",
        desc3: "The penguin cannot capture any 'large' or 'predator' pieces. It can capture any other piece within one square of itself and use a rotate ability after the capture",
      },
      rhino: {
        desc1: "The rhino can move 'back left', 'back right' or two forward as part of its regular movement",
        desc2: "The rhino has an ability called 'trample' where captures ALL pieces in the path of its movement",
        desc3: 'Once per game a rhino may perform a charge of 3 squares ahead if any animal is present in any of the 3 squares directly infront of the rhino',
        desc4: 'The rhino has a special ability called "rhino defence" where the rhino cannot be captured from \'the front\'',
        desc5: "The rhino has an ability called 'lane' where if it has not moved and the friendly piece directly to its left or right has not moved, it can switch places with that piece for its turn",
      },
      snake: {
        desc1: 'The snake can move 2 squares only in orthagonal directions, including through other pieces for its regular movement',
        desc2: 'If its regular movement is blocked by a wall or a piece it cannot capture, its regular movement becomes 1',
        desc3: 'The snake has an ability called "strike" where if an animal is exactly 3 squares ahead of it and there are no pieces between, it can \'strike\' forward and capture that animal',
        desc4: 'The snake has an ability called "shed" where once per game if the snake is captured, it will return to the first rank of the board, in the same column, as if it had a second life. If the first rank is not a valid square for the snake to move to, it is permanently captured',
      },
      tree: {
        desc1: 'The tree may move one forward or unlimitedly side to side if not blocked by any other piece',
        desc2: "The tree has a special ability called 'house' where any piece that can 'climb' tree's may sit on top of the tree piece. If an enemy piece attacks a tree with a housed piece, the housed piece is captured and the tree houses the enemy piece",
        desc3: 'When a piece is housed in the tree, if an enemy piece cannot climb the tree, both the tree and the housed piece are protected from capture',
      },
      wolf: {
        desc1: 'The wolf moves in an L shape like a knight in chess for its regular movement',
        desc2: "If the wolf is the last piece on the board* it's ability 'lone wolf' is activated and it moves in a long L instead as pictured above. *The wolf will enter lone if on a team with a fainted goat or infecting virus",
      },
      virus: {
        desc1: "The virus may move 2 squares in any straight line for its regular movement, it does not capture but uses its ability 'infect' to cause the piece to be infected rather than captured",
        desc2: "The virus can only move to any animal piece, if blocked by a wall, the virus's regular movement is only 1 square",
        desc3: "When an animal piece is 'infected' if the virus leaves the infected piece in to another piece, the piece it left is captured and the new piece is 'infected'",
        desc4: "The virus has an ability called 'infectious' which allows the virus to complete as many valid moves in one move as it likes, capturing multiple animals in one turn",
        desc5: "While not 'infecting' the virus can be captured like any other piece, if an animal captures an infected piece, it becomes infected",
      },
    },
  },
};
